import useTranslation from "next-translate/useTranslation";
import { StarFill } from "react-bootstrap-icons";
import { isTruthy } from "../../helpers/application";

const Rating = (props) => {
  const { t } = useTranslation("common");

  return (
    isTruthy(props.rating) && (
      <>
        {parseInt(props.rating) === 0 ? (
          t("new")
        ) : (
          <span className="d-flex">
            <StarFill size={10} /> &nbsp;
            {props.rating.toFixed(1)}
          </span>
        )}
      </>
    )
  );
};

export default Rating;
